const rules = {
  visitor: {
    static: ["login:visit", "home:visit", "att-cnbd:visit"],
  },
  admin: {
    static: [
      "jobs:visit",
      "timesheets:visit",
      "itrequest:visit",
      "login:visit",
      "home:visit",
      "profile:visit",
      "account-manager:visit",
      "users:add",
      "users:remove",
      "users:edit",
      "att-cnbd:visit",
    ],
  },
};

export default rules;
